<template lang="html">
  <div class="product-comment" v-if="count > 0">
    <div class="title" @click="commentLink()">
      <div class="title-text">
        用户评价
        <p>{{ `(${count})` }}</p>
      </div>
      <a href="javascript:;">
        <div class="more">
          <span v-if="praiseRate >= 95">好评率 {{ praiseRate }}%</span>
          <i class="moreIcon" />
        </div>
      </a>
    </div>
    <div class="comment-list-wrapper">
      <commentItem
        :comment="comment"
        :isCzjSpu="isCzjSpu"
        :showServer="false"
        :ommitContent="true"
        v-for="comment in commentList"
        :key="comment.id"
      ></commentItem>
    </div>

    <div class="seeAllComment" v-if="count > 2">
      <a href="javascript:;" @click="commentLink()"
        >查看更多<i class="iconfont icon-youjiantou"></i
      ></a>
    </div>
  </div>
  <div class="no-comment" v-else><p>暂无评价</p></div>
</template>

<script>
import commentItem from '@/components/common/comment/item'
import { mapState } from 'vuex'

export default {
  props: {
    comments: {
      type: Array,
      default() {
        return []
      }
    },
    praiseRate: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 0
    },
    spuId: {
      type: [Number, String],
      default: ''
    }
  },
  mounted() {
    setTimeout(() => {
      this.$emit('offset', this.$el.offsetTop)
    }, 500)
  },
  data() {
    return {}
  },
  methods: {
    commentLink() {
      if (this.isCzjSpu) {
        const url = `//m.czj100.com/comment/${this.product.spuId}?type=4&title=${this.product.spuName}`
        location.href = `//app.czj100.com/webridge.html?url=${encodeURIComponent(
          url
        )}&uid=${this.$$cookie('uid')}&skey=${this.$$cookie('skey')}`
      } else {
        this.$router.push(`/product/${this.spuId}/comments`)
      }
    }
  },
  computed: {
    ...mapState(['product', 'isCzjSpu']),
    commentList() {
      if (this.comments.length > 2) {
        return this.comments.slice(0, 2)
      } else {
        return this.comments
      }
    },
    // newskuId() {
    //     return this.skuId
    // },
    numComment() {
      let num = this.count
      if (num > 9999) {
        num = `${parseFloat(Number(num / 10000).toFixed(1))}万`
      }
      return num
    }
  },
  components: {
    commentItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.no-comment {
  background: #fff;
  margin-top: rem(20px);
  padding: rem(24px) 0 rem(18px) 0;
  p {
    font-size: rem(38px);
    color: #121212;
    margin-left: rem(24px);
    font-weight: bold;
  }
}
.product-comment {
  background: #fff;
  margin-top: rem(20px);
  padding: rem(24px) 0 rem(30px) 0;

  p {
    font-size: rem(38px);
    color: #121212;
    margin-left: rem(24px);
    font-weight: bold;
  }
  .title {
    margin-left: rem(24px);
    margin-bottom: rem(32px);
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    &-text {
      display: flex;
      font-size: rem(38px);
      color: #121212;
      font-weight: bold;
    }
    p {
      margin-left: rem(5px);
      font-size: rem(30px);
      color: #666;
      vertical-align: baseline;
      font-weight: normal;
    }
    .more {
      margin-right: rem(24px);
      min-width: rem(100px);
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: rem(24px);
      color: #ff5900;
      line-height: rem(30px);
    }
    .moreIcon {
      margin-left: rem(10px);
      width: rem(20px);
      height: rem(20px);
      background: url('~@/assets/images/comment/icon-more.png') no-repeat center
        center;
      background-size: 100% 100%;
    }
  }

  .seeAllComment {
    margin: 0 auto;
    width: rem(270px);
    height: rem(60px);
    text-align: center;
    @include border(all, #dbdbdb, 1px, 30px, solid);

    a {
      height: rem(50px);
      font-size: rem(28px);
      text-align: center;
      color: #333;
      line-height: rem(60px);
    }
    .icon-youjiantou {
      font-size: rem(30px);
      color: #333;
      display: inline-block;
    }
  }
  .comment-list-wrapper {
    position: relative;

    > a {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      z-index: 1;
    }
  }
}
</style>
